import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { payrollActions as actions, notificationActions } from '../actions';
import { payrollServices } from '../services';

/* Get Employee Details By Pay Days Sagas */
function* handleGetEmployeeDetailsByPayDaysRequest() {
  const action = yield take(actions.getEmployeeDetailsByPayDaysRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEmployeeDetailsByPayDays, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeDetailsByPayDaysError(res));
    } else {
      yield put(actions.getEmployeeDetailsByPayDaysSuccess(res));
    }
  } catch (error) {
    yield put(actions.getEmployeeDetailsByPayDaysError());
  }
}

/* Get Attendance Status Sagas*/
function* handleGetAttendanceStatusRequest() {
  const action = yield take(actions.getAttendanceStatusRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAttendanceStatus, dataParams);

    if (res.isError) {
      yield put(actions.getAttendanceStatusError(res));

    } else {
      yield put(actions.getAttendanceStatusSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAttendanceStatusError());
  }
}

/*  Update Attendance Tracking Sagas*/
function* handleUpdateAttendanceTrackingRequest() {
  const action = yield take(actions.updateAttendanceTrackingRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateAttendanceTracking, dataParams);

    if (res.isError) {
      yield put(actions.updateAttendanceTrackingError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateAttendanceTrackingSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateAttendanceTrackingError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Add Earnings Sagas*/
function* handleAddEarningsRequest() {
  const action = yield take(actions.addEarningsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addEarnings, dataParams);

    if (res.isError) {
      yield put(actions.addEarningsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addEarningsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addEarningsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Earnings Sagas*/
function* handleUpdateEarningsRequest() {
  const action = yield take(actions.updateEarningsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateEarnings, dataParams);

    if (res.isError) {
      yield put(actions.updateEarningsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateEarningsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateEarningsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/*  Get Earnings Sagas*/
function* handleGetEarningsRequest() {
  const action = yield take(actions.getEarningsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEarnings, dataParams);

    if (res.isError) {
      yield put(actions.getEarningsError(res));

    } else {
      yield put(actions.getEarningsSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEarningsError());
  }
}

/*  Add Deductions Sagas*/
function* handleAddDeductionsRequest() {
  const action = yield take(actions.addDeductionsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addDeductions, dataParams);

    if (res.isError) {
      yield put(actions.addDeductionsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addDeductionsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addDeductionsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Deductions Sagas*/
function* handleUpdateDeductionsRequest() {
  const action = yield take(actions.updateDeductionsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateDeductions, dataParams);

    if (res.isError) {
      yield put(actions.updateDeductionsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateDeductionsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateDeductionsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Deductions Sagas*/
function* handleGetDeductionsRequest() {
  const action = yield take(actions.getDeductionsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getDeductions, dataParams);

    if (res.isError) {
      yield put(actions.getDeductionsError(res));

    } else {
      yield put(actions.getDeductionsSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDeductionsError());
  }
}

/*  Get Deductions Sagas*/
function* handleAddTaxSlabsRequest() {
  const action = yield take(actions.addTaxSlabsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addTaxSlabs, dataParams);

    if (res.isError) {
      yield put(actions.addTaxSlabsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addTaxSlabsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addTaxSlabsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Add Earning Types Sagas*/
function* handleAddEarningTypesRequest() {
  const action = yield take(actions.addEarningTypesRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addEarningTypes, dataParams);

    if (res.isError) {
      yield put(actions.addEarningTypesError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addEarningTypesSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addEarningTypesError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/*  Update Earning Types Sagas*/
function* handleUpdateEarningTypesRequest() {
  const action = yield take(actions.updateEarningTypesRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateEarningTypes, dataParams);

    if (res.isError) {
      yield put(actions.updateEarningTypesError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateEarningTypesSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateEarningTypesError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Earning Types Sagas*/
function* handleGetEarningTypeRequest() {
  const action = yield take(actions.getEarningTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEarningType, dataParams);

    if (res.isError) {
      yield put(actions.getEarningTypeError(res));

    } else {
      yield put(actions.getEarningTypeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEarningTypeError());
  }
}

/*  Get All Earning Types Sagas*/
function* handleGetAllEarningTypeRequest() {
  const action = yield take(actions.getAllEarningTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllEarningType, dataParams);

    if (res.isError) {
      yield put(actions.getAllEarningTypeError(res));

    } else {
      yield put(actions.getAllEarningTypeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllEarningTypeError());
  }
}

/*  Get All Earning Types By Id Sagas*/
function* handleGetEarningTypeByIdRequest() {
  const action = yield take(actions.getEarningTypeByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEarningTypeById, dataParams);

    if (res.isError) {
      yield put(actions.getEarningTypeByIdError(res));

    } else {
      yield put(actions.getEarningTypeByIdSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEarningTypeByIdError());
  }
}


/*  Add Earning Types Sagas*/
function* handleAddDeductionTypesRequest() {
  const action = yield take(actions.addDeductionTypesRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addDeductionTypes, dataParams);

    if (res.isError) {
      yield put(actions.addDeductionTypesError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addDeductionTypesSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addDeductionTypesError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/*  Update Deduction Types Sagas*/
function* handleUpdateDeductionTypesRequest() {
  const action = yield take(actions.updateDeductionTypesRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateDeductionTypes, dataParams);

    if (res.isError) {
      yield put(actions.updateDeductionTypesError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateDeductionTypesSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateDeductionTypesError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Deduction Types Sagas*/
function* handleGetDeductionTypeRequest() {
  const action = yield take(actions.getDeductionTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getDeductionType, dataParams);

    if (res.isError) {
      yield put(actions.getDeductionTypeError(res));

    } else {
      yield put(actions.getDeductionTypeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDeductionTypeError());
  }
}

/*  Get All Deduction Types Sagas*/
function* handleGetAllDeductionTypeRequest() {
  const action = yield take(actions.getAllDeductionTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllDeductionType, dataParams);

    if (res.isError) {
      yield put(actions.getAllDeductionTypeError(res));

    } else {
      yield put(actions.getAllDeductionTypeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllDeductionTypeError());
  }
}

/*  Get All Deduction Types By Id Sagas*/
function* handleGetDeductionTypeByIdRequest() {
  const action = yield take(actions.getDeductionTypeByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getDeductionTypeById, dataParams);

    if (res.isError) {
      yield put(actions.getDeductionTypeByIdError(res));

    } else {
      yield put(actions.getDeductionTypeByIdSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDeductionTypeByIdError());
  }
}

/*  Generate Salary template Sagas*/
function* handleGenerateSalaryTemplateRequest() {
  const action = yield take(actions.generateSalaryTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.generateSalaryTemplate, dataParams);

    if (res.isError) {
      yield put(actions.generateSalaryTemplateError(res));
      // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.generateSalaryTemplateSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.generateSalaryTemplateError());
    // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Save Salary Template Sagas*/
function* handleSaveSalaryTemplateRequest() {
  const action = yield take(actions.saveSalaryTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.saveSalaryTemplate, dataParams);

    if (res.isError) {
      yield put(actions.saveSalaryTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.saveSalaryTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.saveSalaryTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  get all salary template Sagas*/
function* handleGetAllSalaryTemplateRequest() {
  const action = yield take(actions.getAllSalaryTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllSalaryTemplate, dataParams);

    if (res.isError) {
      yield put(actions.getAllSalaryTemplateError(res));

    } else {
      yield put(actions.getAllSalaryTemplateSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllSalaryTemplateError());
  }
}

/*  Get Salary Template Sagas*/
function* handleGetSalaryTemplateRequest() {
  const action = yield take(actions.getSalaryTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getSalaryTemplate, dataParams);

    if (res.isError) {
      yield put(actions.getSalaryTemplateError(res));

    } else {
      yield put(actions.getSalaryTemplateSuccess(res));
    }

  } catch (error) {
    yield put(actions.getSalaryTemplateError());
  }
}

/*  Update Salary Template Sagas*/
function* handleUpdateSalaryTemplateRequest() {
  const action = yield take(actions.updateSalaryTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateSalaryTemplate, dataParams);

    if (res.isError) {
      yield put(actions.updateSalaryTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateSalaryTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateSalaryTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  GET Salary Template by id Sagas*/
function* handleGetSalaryTemplateByIdRequest() {
  const action = yield take(actions.getSalaryTemplateByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getSalaryTemplateById, dataParams);

    if (res.isError) {
      yield put(actions.getSalaryTemplateByIdError(res));

    } else {
      yield put(actions.getSalaryTemplateByIdSuccess(res));
    }

  } catch (error) {
    yield put(actions.getSalaryTemplateByIdError());
  }
}


/*  Get All Earning Sagas*/
function* handleGetAllEaringRequest() {
  const action = yield take(actions.getAllEarningRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllEarning, dataParams);

    if (res.isError) {
      yield put(actions.getAllEarningError(res));
      // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.getAllEarningSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.getAllEarningError());
    // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get All deduction Sagas*/
function* handleGetAllDeductionRequest() {
  const action = yield take(actions.getAllDeductionRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllDeduction, dataParams);

    if (res.isError) {
      yield put(actions.getAllDeductionError(res));
      // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.getAllDeductionSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.getAllDeductionError());
    // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Calculate Ctc Sagas*/
function* handleCalculateCtcRequest() {
  const action = yield take(actions.calculateCtcRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.calculateCtc, dataParams);
    if (res.isError) {
      yield put(actions.calculateCtcError(res));
    } else {
      yield put(actions.calculateCtcSuccess(res));
    }

  } catch (error) {
    yield put(actions.calculateCtcError());

  }
}

/*  Add Arrears Sagas*/
function* handleAddArrearsRequest() {
  const action = yield take(actions.addArrearsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addArrears, dataParams);

    if (res.isError) {
      yield put(actions.addArrearsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addArrearsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addArrearsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Calculate Ctc Sagas*/
function* handleGetArrearsRequest() {
  const action = yield take(actions.getArrearsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getArrears, dataParams);

    if (res.isError) {
      yield put(actions.getArrearsError(res));

    } else {
      yield put(actions.getArrearsSuccess(res));
    }

  } catch (error) {
    yield put(actions.getArrearsError());
  }
}

/*  Add Employee Salary Sagas*/
function* handleAddEmployeeSalaryRequest() {
  const action = yield take(actions.addEmployeeSalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addEmployeeSalary, dataParams);

    if (res.isError) {
      yield put(actions.addEmployeeSalaryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addEmployeeSalarySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addEmployeeSalaryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Employee Salary Sagas*/
function* handleGetEmployeeSalaryRequest() {
  const action = yield take(actions.getEmployeeSalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEmployeeSalary, dataParams);

    if (res.isError) {
      yield put(actions.getEmployeeSalaryError(res));

    } else {
      yield put(actions.getEmployeeSalarySuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeSalaryError());
  }
}

/*  Update Employee Salary Sagas*/
function* handleUpdateEmployeeSalaryRequest() {
  const action = yield take(actions.updateEmployeeSalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateEmployeeSalary, dataParams);

    if (res.isError) {
      yield put(actions.updateEmployeeSalaryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateEmployeeSalarySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateEmployeeSalaryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get All Employee Assign Status Sagas*/
function* handleGetAllEmployeeAssignStatusRequest() {
  const action = yield take(actions.getAllEmployeeAssignStatusRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllEmployeeAssignStatus, dataParams);

    if (res.isError) {
      yield put(actions.getAllEmployeeAssignStatusError(res));

    } else {
      yield put(actions.getAllEmployeeAssignStatusSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllEmployeeAssignStatusError());
  }
}

/*  Add Pay Sagas*/
function* handleAddPayRunRequest() {
  const action = yield take(actions.addPayRunRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addPayRun, dataParams);

    if (res.isError) {
      yield put(actions.addPayRunError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addPayRunSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addPayRunError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Add Pay Schedule Sagas*/
function* handleAddPayScheduleRequest() {
  const action = yield take(actions.addPayScheduleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addPaySchedule, dataParams);
    if (res.isError) {
      yield put(actions.addPayScheduleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addPayScheduleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addPayScheduleError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Pay Schedule Sagas*/
function* handleUpcomingPayrollsRequest() {
  const action = yield take(actions.upcomingPayrollsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.upcomingPayrolls, dataParams);
    if (res.isError) {
      yield put(actions.upcomingPayrollsError(res));
    } else {
      yield put(actions.upcomingPayrollsSuccess(res));
    }

  } catch (error) {
    yield put(actions.upcomingPayrollsError());
  }
}

/*  Update Pay Schedule Sagas*/
function* handleUpdatePayScheduleRequest() {
  const action = yield take(actions.updatePayScheduleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updatePaySchedule, dataParams);
    if (res.isError) {
      yield put(actions.updatePayScheduleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updatePayScheduleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updatePayScheduleError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Pay Roll Notification Sagas*/
function* handlePayRollNotificationRequest() {
  const action = yield take(actions.payRollNotificationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.payRollNotification, dataParams);
    if (res.isError) {
      yield put(actions.payRollNotificationError(res));
    } else {
      yield put(actions.payRollNotificationSuccess(res));
    }

  } catch (error) {
    yield put(actions.payRollNotificationError());
  }
}

/* Get Pay Run Sagas*/
function* handleGetPayRunRequest() {
  const action = yield take(actions.getPayRunRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getPayRun, dataParams);
    if (res.isError) {
      yield put(actions.getPayRunError(res));
    } else {
      yield put(actions.getPayRunSuccess(res));
    }

  } catch (error) {
    yield put(actions.getPayRunError());
  }
}

/* Get Pay Run Sagas*/
function* handleGetPayRunDashboardDataRequest() {
  const action = yield take(actions.getPayRunDashboardDataRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getPayRunDashboardData, dataParams);
    if (res.isError) {
      yield put(actions.getPayRunDashboardDataError(res));
    } else {
      yield put(actions.getPayRunDashboardDataSuccess(res));
    }

  } catch (error) {
    yield put(actions.getPayRunDashboardDataError());
  }
}

/*  Get Pay Run History Sagas*/
function* handleGetPayRunHistoryRequest() {
  const action = yield take(actions.getPayRunHistoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getPayRunHistory, dataParams);
    if (res.isError) {
      yield put(actions.getPayRunHistoryError(res));
    } else {
      yield put(actions.getPayRunHistorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getPayRunHistoryError());
  }
}

/*  Get Pay Run History Sagas*/
function* handleApprovePayrollRequest() {
  const action = yield take(actions.approvePayrollRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.approvePayroll, dataParams);
    if (res.isError) {
      yield put(actions.approvePayrollError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.approvePayrollSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.approvePayrollError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Add Tax Slab Sagas*/
function* handleAddTaxSlabRequest() {
  const action = yield take(actions.addTaxSlabRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addTaxSlab, dataParams);
    if (res.isError) {
      yield put(actions.addTaxSlabError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addTaxSlabSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addTaxSlabError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Tax Slab Sagas*/
function* handleUpdateTaxSlabRequest() {
  const action = yield take(actions.updateTaxSlabRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateTaxSlab, dataParams);
    if (res.isError) {
      yield put(actions.updateTaxSlabError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateTaxSlabSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateTaxSlabError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Tax Slab Sagas*/
function* handleGetTaxSlabRequest() {
  const action = yield take(actions.getTaxSlabRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getTaxSlab, dataParams);
    if (res.isError) {
      yield put(actions.getTaxSlabError(res));
    } else {
      yield put(actions.getTaxSlabSuccess(res));
    }

  } catch (error) {
    yield put(actions.getTaxSlabError());
  }
}


/*  Get All Tax Slab Sagas*/
function* handleGetAllTaxSlabRequest() {
  const action = yield take(actions.getAllTaxSlabRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllTaxSlab, dataParams);
    if (res.isError) {
      yield put(actions.getAllTaxSlabError(res));
    } else {
      yield put(actions.getAllTaxSlabSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllTaxSlabError());
  }
}

/*  Delete Tax Slab Sagas*/
function* handleDeleteTaxSlabRequest() {
  const action = yield take(actions.deleteTaxSlabRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteTaxSlab, dataParams);
    if (res.isError) {
      yield put(actions.deleteTaxSlabError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteTaxSlabSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteTaxSlabError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Add Employee Investment Sagas*/
function* handleAddEmployeeInvestmentRequest() {
  const action = yield take(actions.addEmployeeInvestmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addEmployeeInvestment, dataParams);
    if (res.isError) {
      yield put(actions.addEmployeeInvestmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addEmployeeInvestmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addEmployeeInvestmentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Employee Investment Sagas*/
function* handleGetEmployeeInvestmentRequest() {
  const action = yield take(actions.getEmployeeInvestmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEmployeeInvestment, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeInvestmentError(res));
    } else {
      yield put(actions.getEmployeeInvestmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeInvestmentError());
  }
}

/*  Update Employee Investment Sagas*/
function* handleUpdateEmployeeInvestmentRequest() {
  const action = yield take(actions.updateEmployeeInvestmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateEmployeeInvestment, dataParams);
    if (res.isError) {
      yield put(actions.updateEmployeeInvestmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateEmployeeInvestmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

    }

  } catch (error) {
    yield put(actions.updateEmployeeInvestmentError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Delete Employee Investment Sagas*/
function* handleDeleteEmployeeInvestmentRequest() {
  const action = yield take(actions.deleteEmployeeInvestmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteEmployeeInvestment, dataParams);
    if (res.isError) {
      yield put(actions.deleteEmployeeInvestmentError(res));
    } else {
      yield put(actions.deleteEmployeeInvestmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.deleteEmployeeInvestmentError());
  }
}

/*  Add Investment Category Sagas*/
function* handleAddInvestmentCategoryRequest() {
  const action = yield take(actions.addInvestmentCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addInvestmentCategory, dataParams);
    if (res.isError) {
      yield put(actions.addInvestmentCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addInvestmentCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addInvestmentCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Investment Category Sagas*/
function* handleUpdateInvestmentCategoryRequest() {
  const action = yield take(actions.updateInvestmentCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateInvestmentCategory, dataParams);
    if (res.isError) {
      yield put(actions.updateInvestmentCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateInvestmentCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateInvestmentCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Investment Category Sagas*/
function* handleGetInvestmentCategoryRequest() {
  const action = yield take(actions.getInvestmentCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getInvestmentCategory, dataParams);
    if (res.isError) {
      yield put(actions.getInvestmentCategoryError(res));
    } else {
      yield put(actions.getInvestmentCategorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getInvestmentCategoryError());
  }
}

/*  Get All Investment Category Sagas*/
function* handleGetAllInvestmentCategoryRequest() {
  const action = yield take(actions.getAllInvestmentCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllInvestmentCategory, dataParams);
    if (res.isError) {
      yield put(actions.getAllInvestmentCategoryError(res));
    } else {
      yield put(actions.getAllInvestmentCategorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllInvestmentCategoryError());
  }
}

/* Delete Investment Category Sagas*/
function* handleDeleteInvestmentCategoryRequest() {
  const action = yield take(actions.deleteInvestmentCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteInvestmentCategory, dataParams);
    if (res.isError) {
      yield put(actions.deleteInvestmentCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteInvestmentCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteInvestmentCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}
/*  Add Investment Category Sagas*/
function* handleAddInvestmentSubCategoryRequest() {
  const action = yield take(actions.addInvestmentSubCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addInvestmentSubCategory, dataParams);

    if (res.isError) {
      yield put(actions.addInvestmentSubCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addInvestmentSubCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addInvestmentSubCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Investment Category Sagas*/
function* handleUpdateInvestmentSubCategoryRequest() {
  const action = yield take(actions.updateInvestmentSubCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateInvestmentSubCategory, dataParams);
    if (res.isError) {
      yield put(actions.updateInvestmentSubCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateInvestmentSubCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateInvestmentSubCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Investment Category Sagas*/
function* handleGetInvestmentSubCategoryRequest() {
  const action = yield take(actions.getInvestmentSubCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getInvestmentSubCategory, dataParams);
    if (res.isError) {
      yield put(actions.getInvestmentSubCategoryError(res));
    } else {
      yield put(actions.getInvestmentSubCategorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getInvestmentSubCategoryError());
  }
}
/*  Get All Investment Category Sagas*/
function* handleGetAllInvestmentSubCategoryRequest() {
  const action = yield take(actions.getAllInvestmentSubCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllInvestmentSubCategory, dataParams);
    if (res.isError) {
      yield put(actions.getAllInvestmentSubCategoryError(res));
    } else {
      yield put(actions.getAllInvestmentSubCategorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllInvestmentSubCategoryError());
  }
}

/*  Delete Investment Category Sagas*/
function* handleDeleteInvestmentSubCategoryRequest() {
  const action = yield take(actions.deleteInvestmentSubCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteInvestmentSubCategory, dataParams);
    if (res.isError) {
      yield put(actions.deleteInvestmentSubCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteInvestmentSubCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteInvestmentSubCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get All Investment Category Details Sagas*/
function* handleGetAllInvestmentCategoryDetailsRequest() {
  const action = yield take(actions.getAllInvestmentCategoryDetailsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllInvestmentCategoryDetails, dataParams);
    if (res.isError) {
      yield put(actions.getAllInvestmentCategoryDetailsError(res));
    } else {
      yield put(actions.getAllInvestmentCategoryDetailsSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllInvestmentCategoryDetailsError());
  }
}



/*  add Loans Sagas*/
function* handleAddLoansRequest() {
  const action = yield take(actions.addLoansRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.addLoans, dataParams);
    if (res.isError) {
      yield put(actions.addLoansError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addLoansSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

    }

  } catch (error) {
    yield put(actions.addLoansError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Update Loans Sagas*/
function* handleUpdateLoansRequest() {
  const action = yield take(actions.updateLoansRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateLoans, dataParams);
    if (res.isError) {
      yield put(actions.updateLoansError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateLoansSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateLoansError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}


/*  Get Loans Sagas*/
function* handleGetLoansRequest() {
  const action = yield take(actions.getLoansRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getLoans, dataParams);
    if (res.isError) {
      yield put(actions.getLoansError(res));
    } else {
      yield put(actions.getLoansSuccess(res));
    }

  } catch (error) {
    yield put(actions.getLoansError());
  }
}

/*  Apply Advance Sagas*/
function* handleApplyAdvanceRequest() {
  const action = yield take(actions.applyAdvanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.applyAdvance, dataParams);
    if (res.isError) {
      yield put(actions.applyAdvanceError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.applyAdvanceSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.applyAdvanceError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Get Advance ApprovalSagas*/
function* handleGetAdvanceApprovalRequest() {
  const action = yield take(actions.getAdvanceApprovalRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAdvanceApproval, dataParams);
    if (res.isError) {
      yield put(actions.getAdvanceApprovalError(res));
    } else {
      yield put(actions.getAdvanceApprovalSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAdvanceApprovalError());
  }
}

/*  Get Advance ApprovalSagas*/
function* handleGetAdvanceRequestRequest() {
  const action = yield take(actions.getAdvanceRequestRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAdvanceRequest, dataParams);
    if (res.isError) {
      yield put(actions.getAdvanceRequestError(res));
    } else {
      yield put(actions.getAdvanceRequestSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAdvanceRequestError());
  }
}

/*  Get Advance ApprovalSagas*/
function* handleApprovalRejectAdvanceRequest() {
  const action = yield take(actions.approvalRejectAdvanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.approvalRejectAdvance, dataParams);
    if (res.isError) {
      yield put(actions.approvalRejectAdvanceError(res));
    } else {
      yield put(actions.approvalRejectAdvanceSuccess(res));
    }

  } catch (error) {
    yield put(actions.approvalRejectAdvanceError());
  }
}

/*  Check Rule Formula Sagas*/
function* handleCheckRuleFormulaRequest() {
  const action = yield take(actions.checkRuleFormulaRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.checkRuleFormula, dataParams);
    if (res.isError) {
      yield put(actions.checkRuleFormulaError(res));
    } else {
      yield put(actions.checkRuleFormulaSuccess(res));
    }

  } catch (error) {
    yield put(actions.checkRuleFormulaError());
  }
}

/*  Employee Investment Proof Sagas*/
function* handleEmployeeInvestmentProofRequest() {
  const action = yield take(actions.employeeInvestmentProofRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.employeeInvestmentProof, dataParams);
    if (res.isError) {
      yield put(actions.employeeInvestmentProofError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.employeeInvestmentProofSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.employeeInvestmentProofError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Employee Investment Proof Sagas*/
function* handleGetEmployeeInvestmentProofRequest() {
  const action = yield take(actions.getEmployeeInvestmentProofRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEmployeeInvestmentProof, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeInvestmentProofError(res));
    } else {
      yield put(actions.getEmployeeInvestmentProofSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeInvestmentProofError());

  }
}

/* update Employee Investment Proof Sagas*/
function* handleUpdateEmployeeInvestmentProofRequest() {
  const action = yield take(actions.updateEmployeeInvestmentProofRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateEmployeeInvestmentProof, dataParams);
    if (res.isError) {
      yield put(actions.updateEmployeeInvestmentProofError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateEmployeeInvestmentProofSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateEmployeeInvestmentProofError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}


/* Delete Employee Investment Proof Sagas*/
function* handleDeleteEmployeeInvestmentProofRequest() {
  const action = yield take(actions.deleteEmployeeInvestmentProofRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteEmployeeInvestmentProof, dataParams);
    if (res.isError) {
      yield put(actions.deleteEmployeeInvestmentProofError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteEmployeeInvestmentProofSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteEmployeeInvestmentProofError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}


/* Comment In Employee Investment Proof Sagas*/
function* handleCommentInEmployeeInvestmentProofRequest() {
  const action = yield take(actions.commentInEmployeeInvestmentProofRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.commentInEmployeeInvestmentProof, dataParams);
    if (res.isError) {
      yield put(actions.commentInEmployeeInvestmentProofError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.commentInEmployeeInvestmentProofSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.commentInEmployeeInvestmentProofError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All employee Salary  Sagas*/
function* handleGetAllEmployeeSalaryRequest() {
  const action = yield take(actions.getAllEmployeeSalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getAllEmployeeSalary, dataParams);
    if (res.isError) {
      yield put(actions.getAllEmployeeSalaryError(res));
    } else {
      yield put(actions.getAllEmployeeSalarySuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllEmployeeSalaryError());

  }
}

/*  Get Employee Salary Monthly Salary Sagas*/
function* handleGetEmployeeMonthlySalaryRequest() {
  const action = yield take(actions.getEmployeeMonthlySalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEmployeeMonthlySalary, dataParams);

    if (res.isError) {
      yield put(actions.getEmployeeMonthlySalaryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.getEmployeeMonthlySalarySuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.getEmployeeMonthlySalaryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Generate Salary Slip Sagas*/
function* handleGenerateSalarySlipRequest() {
  const action = yield take(actions.generateSalarySlipRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.generateSalarySlip, dataParams);

    if (res.isError) {
      yield put(actions.generateSalarySlipError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.generateSalarySlipSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.generateSalarySlipError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Send Offer Letter Sagas*/
function* handleSendOfferLetterRequest() {
  const action = yield take(actions.sendOfferLetterRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.sendOfferLetter, dataParams);

    if (res.isError) {
      yield put(actions.sendOfferLetterError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.sendOfferLetterSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.sendOfferLetterError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/*  Get Candidate Salary Sagas*/
function* handleGetCandidateSalaryRequest() {
  const action = yield take(actions.getCandidateSalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getCandidateSalary, dataParams);

    if (res.isError) {
      yield put(actions.getCandidateSalaryError(res));
    } else {
      yield put(actions.getCandidateSalarySuccess(res));
    }

  } catch (error) {
    yield put(actions.getCandidateSalaryError());

  }
}


/*  Get Candidate Salary Sagas*/
function* handleUpdateEmployeeMonthlySalaryRequest() {
  const action = yield take(actions.updateEmployeeMonthlySalaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.updateEmployeeMonthlySalary, dataParams);
    if (res.isError) {
      yield put(actions.updateEmployeeMonthlySalaryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateEmployeeMonthlySalarySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateEmployeeMonthlySalaryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}

/*  Get Candidate Salary Sagas*/
function* handleDeleteEarningTypeRequest() {
  const action = yield take(actions.deleteEarningTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteEarningType, dataParams);
    if (res.isError) {
      yield put(actions.deleteEarningTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteEarningTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteEarningTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}

/*  Get Candidate Salary Sagas*/
function* handleDeleteDeductionTypeRequest() {
  const action = yield take(actions.deleteDeductionTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteDeductionType, dataParams);
    if (res.isError) {
      yield put(actions.deleteDeductionTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteDeductionTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteDeductionTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}


/*  Get Candidate Salary Sagas*/
function* handleDeleteDeductionRequest() {
  const action = yield take(actions.deleteDeductionRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteDeduction, dataParams);
    if (res.isError) {
      yield put(actions.deleteDeductionError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteDeductionSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteDeductionError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}

/*  Get Candidate Salary Sagas*/
function* handleDeleteEarningRequest() {
  const action = yield take(actions.deleteEarningRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteEarning, dataParams);
    if (res.isError) {
      yield put(actions.deleteEarningError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteEarningSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteEarningError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}

/*  Get Candidate Salary Sagas*/
function* handleDeleteSalaryTemplateRequest() {
  const action = yield take(actions.deleteSalaryTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.deleteSalaryTemplate, dataParams);
    if (res.isError) {
      yield put(actions.deleteSalaryTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteSalaryTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteSalaryTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}


/*  Get Candidate Salary Sagas*/
function* handleGetEmployeeMonthlyPaySlipRequest() {
  const action = yield take(actions.getEmployeeMonthlyPaySlipRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(payrollServices.getEmployeeMonthlyPaySlip, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeMonthlyPaySlipError(res));
       yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.getEmployeeMonthlyPaySlipSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeMonthlyPaySlipError());
     yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}



/* -----------Watchers------------- */
function* handleGetEmployeeDetailsByPayDaysWatcher() {
  yield takeEvery(
    actions.getEmployeeDetailsByPayDaysRequest,
    handleGetEmployeeDetailsByPayDaysRequest,
  );
}

function* handleGetAttendanceStatusWatcher() {
  yield takeEvery(
    actions.getAttendanceStatusRequest,
    handleGetAttendanceStatusRequest,
  );
}

function* handleUpdateAttendanceTrackingWatcher() {
  yield takeEvery(
    actions.updateAttendanceTrackingRequest,
    handleUpdateAttendanceTrackingRequest,
  );
}

function* handleAddEarningsWatcher() {
  yield takeEvery(
    actions.addEarningsRequest,
    handleAddEarningsRequest,
  );
}

function* handleUpdateEarningsWatcher() {
  yield takeEvery(
    actions.updateEarningsRequest,
    handleUpdateEarningsRequest,
  );
}

function* handleGetEarningsWatcher() {
  yield takeEvery(
    actions.getEarningsRequest,
    handleGetEarningsRequest,
  );
}

function* handleAddDeductionsWatcher() {
  yield takeEvery(
    actions.addDeductionsRequest,
    handleAddDeductionsRequest,
  );
}

function* handleUpdateDeductionsWatcher() {
  yield takeEvery(
    actions.updateDeductionsRequest,
    handleUpdateDeductionsRequest,
  );
}

function* handleGetDeductionsWatcher() {
  yield takeEvery(
    actions.getDeductionsRequest,
    handleGetDeductionsRequest,
  );
}

function* handleAddTaxSlabsWatcher() {
  yield takeEvery(
    actions.addTaxSlabsRequest,
    handleAddTaxSlabsRequest,
  );
}

function* handleAddEarningTypesWatcher() {
  yield takeEvery(
    actions.addEarningTypesRequest,
    handleAddEarningTypesRequest,
  );
}

function* handleUpdateEarningTypesWatcher() {
  yield takeEvery(
    actions.updateEarningTypesRequest,
    handleUpdateEarningTypesRequest,
  );
}


function* handleGetEarningTypeWatcher() {
  yield takeEvery(
    actions.getEarningTypeRequest,
    handleGetEarningTypeRequest,
  );
}

function* handleGetAllEarningTypeWatcher() {
  yield takeEvery(
    actions.getAllEarningTypeRequest,
    handleGetAllEarningTypeRequest,
  );
}

function* handleGetEarningTypeByIdWatcher() {
  yield takeEvery(
    actions.getEarningTypeByIdRequest,
    handleGetEarningTypeByIdRequest,
  );
}

function* handleAddDeductionTypesWatcher() {
  yield takeEvery(
    actions.addDeductionTypesRequest,
    handleAddDeductionTypesRequest,
  );
}

function* handleUpdateDeductionTypesWatcher() {
  yield takeEvery(
    actions.updateDeductionTypesRequest,
    handleUpdateDeductionTypesRequest,
  );
}


function* handleGetDeductionTypeWatcher() {
  yield takeEvery(
    actions.getDeductionTypeRequest,
    handleGetDeductionTypeRequest,
  );
}

function* handleGetAllDeductionTypeWatcher() {
  yield takeEvery(
    actions.getAllDeductionTypeRequest,
    handleGetAllDeductionTypeRequest,
  );
}

function* handleGetDeductionTypeByIdWatcher() {
  yield takeEvery(
    actions.getDeductionTypeByIdRequest,
    handleGetDeductionTypeByIdRequest,
  );
}

function* handleGenerateSalaryTemplateWatcher() {
  yield takeEvery(
    actions.generateSalaryTemplateSuccess,
    handleGenerateSalaryTemplateRequest,
  );
}

function* handleSaveSalaryTemplateWatcher() {
  yield takeEvery(
    actions.saveSalaryTemplateRequest,
    handleSaveSalaryTemplateRequest,
  );
}

function* handleGetAllSalaryTemplateWatcher() {
  yield takeEvery(
    actions.getAllSalaryTemplateRequest,
    handleGetAllSalaryTemplateRequest,
  );
}

function* handleGetSalaryTemplateWatcher() {
  yield takeEvery(
    actions.getSalaryTemplateRequest,
    handleGetSalaryTemplateRequest,
  );
}

function* handleUpdateSalaryTemplateWatcher() {
  yield takeEvery(
    actions.updateSalaryTemplateRequest,
    handleUpdateSalaryTemplateRequest,
  );
}

function* handleGetSalaryTemplateByIdWatcher() {
  yield takeEvery(
    actions.getSalaryTemplateByIdRequest,
    handleGetSalaryTemplateByIdRequest,
  );
}


function* handleGetAllEarningWatcher() {
  yield takeEvery(
    actions.getAllEarningRequest,
    handleGetAllEaringRequest,
  );
}

function* handleGetAllDeductionWatcher() {
  yield takeEvery(
    actions.getAllDeductionRequest,
    handleGetAllDeductionRequest,
  );
}

function* handleCalculateCtcWatcher() {
  yield takeEvery(
    actions.calculateCtcRequest,
    handleCalculateCtcRequest,
  );
}

function* handleAddArrearsWatcher() {
  yield takeEvery(
    actions.addArrearsRequest,
    handleAddArrearsRequest,
  );
}
function* handleGetArrearsWatcher() {
  yield takeEvery(
    actions.getArrearsRequest,
    handleGetArrearsRequest,
  );
}

function* handleAddEmployeeSalaryWatcher() {
  yield takeEvery(
    actions.addEmployeeSalaryRequest,
    handleAddEmployeeSalaryRequest,
  );
}

function* handleGetEmployeeSalaryWatcher() {
  yield takeEvery(
    actions.getEmployeeSalaryRequest,
    handleGetEmployeeSalaryRequest,
  );
}

function* handleUpdateEmployeeSalaryWatcher() {
  yield takeEvery(
    actions.updateEmployeeSalaryRequest,
    handleUpdateEmployeeSalaryRequest,
  );
}

function* handleGetAllEmployeeAssignStatusWatcher() {
  yield takeEvery(
    actions.getAllEmployeeAssignStatusRequest,
    handleGetAllEmployeeAssignStatusRequest,
  );
}

function* handleAddPayRunWatcher() {
  yield takeEvery(
    actions.addPayRunRequest,
    handleAddPayRunRequest,
  );
}

function* handleAddPayScheduleWatcher() {
  yield takeEvery(
    actions.addPayScheduleRequest,
    handleAddPayScheduleRequest,
  );
}

function* handleUpdatePayScheduleWatcher() {
  yield takeEvery(
    actions.updatePayScheduleRequest,
    handleUpdatePayScheduleRequest,
  );
}

function* handleUpcomingPayrollsWatcher() {
  yield takeEvery(
    actions.upcomingPayrollsRequest,
    handleUpcomingPayrollsRequest,
  );
}

function* handlePayRollNotificationWatcher() {
  yield takeEvery(
    actions.payRollNotificationRequest,
    handlePayRollNotificationRequest,
  );
}

function* handleGetPayRunWatcher() {
  yield takeEvery(
    actions.getPayRunRequest,
    handleGetPayRunRequest,
  );
}

function* handleGetPayRunDashboardDataWatcher() {
  yield takeEvery(
    actions.getPayRunDashboardDataRequest,
    handleGetPayRunDashboardDataRequest,
  );
}

function* handleGetPayRunHistoryWatcher() {
  yield takeEvery(
    actions.getPayRunHistoryRequest,
    handleGetPayRunHistoryRequest,
  );
}

function* handleApprovePayrollWatcher() {
  yield takeEvery(
    actions.approvePayrollRequest,
    handleApprovePayrollRequest,
  );
}

function* handleAddTaxSlabWatcher() {
  yield takeEvery(
    actions.addTaxSlabRequest,
    handleAddTaxSlabRequest,
  );
}

function* handleUpdateTaxSlabWatcher() {
  yield takeEvery(
    actions.updateTaxSlabRequest,
    handleUpdateTaxSlabRequest,
  );
}

function* handleGetTaxSlabWatcher() {
  yield takeEvery(
    actions.getTaxSlabRequest,
    handleGetTaxSlabRequest,
  );
}

function* handleGetAllTaxSlabWatcher() {
  yield takeEvery(
    actions.getAllTaxSlabRequest,
    handleGetAllTaxSlabRequest,
  );
}

function* handleDeleteTaxSlabWatcher() {
  yield takeEvery(
    actions.deleteTaxSlabRequest,
    handleDeleteTaxSlabRequest,
  );
}

function* handleAddEmployeeInvestmentWatcher() {
  yield takeEvery(
    actions.addEmployeeInvestmentRequest,
    handleAddEmployeeInvestmentRequest,
  );
}

function* handleGetEmployeeInvestmentWatcher() {
  yield takeEvery(
    actions.getEmployeeInvestmentRequest,
    handleGetEmployeeInvestmentRequest,
  );
}

function* handleUpdateEmployeeInvestmentWatcher() {
  yield takeEvery(
    actions.updateEmployeeInvestmentRequest,
    handleUpdateEmployeeInvestmentRequest,
  );
}

function* handleDeleteEmployeeInvestmentWatcher() {
  yield takeEvery(
    actions.deleteEmployeeInvestmentRequest,
    handleDeleteEmployeeInvestmentRequest,
  );
}

function* handleAddInvestmentCategoryWatcher() {
  yield takeEvery(
    actions.addInvestmentCategoryRequest,
    handleAddInvestmentCategoryRequest,
  );
}

function* handleUpdateInvestmentCategoryWatcher() {
  yield takeEvery(
    actions.updateInvestmentCategoryRequest,
    handleUpdateInvestmentCategoryRequest,
  );
}

function* handleGetInvestmentCategoryWatcher() {
  yield takeEvery(
    actions.getInvestmentCategoryRequest,
    handleGetInvestmentCategoryRequest,
  );
}

function* handleGetAllInvestmentCategoryWatcher() {
  yield takeEvery(
    actions.getAllInvestmentCategoryRequest,
    handleGetAllInvestmentCategoryRequest,
  );
}
function* handleDeleteInvestmentCategoryWatcher() {
  yield takeEvery(
    actions.deleteInvestmentCategoryRequest,
    handleDeleteInvestmentCategoryRequest,
  );
}

function* handleAddInvestmentSubCategoryWatcher() {
  yield takeEvery(
    actions.addInvestmentSubCategoryRequest,
    handleAddInvestmentSubCategoryRequest,
  );
}

function* handleUpdateInvestmentSubCategoryWatcher() {
  yield takeEvery(
    actions.updateInvestmentSubCategoryRequest,
    handleUpdateInvestmentSubCategoryRequest,
  );
}


function* handleGetInvestmentSubCategoryWatcher() {
  yield takeEvery(
    actions.getInvestmentSubCategoryRequest,
    handleGetInvestmentSubCategoryRequest,
  );
}

function* handleGetAllInvestmentSubCategoryWatcher() {
  yield takeEvery(
    actions.getAllInvestmentSubCategoryRequest,
    handleGetAllInvestmentSubCategoryRequest,
  );
}

function* handleDeleteInvestmentSubCategoryWatcher() {
  yield takeEvery(
    actions.deleteInvestmentSubCategoryRequest,
    handleDeleteInvestmentSubCategoryRequest,
  );
}

function* handleGetAllInvestmentCategoryDetailsWatcher() {
  yield takeEvery(
    actions.getAllInvestmentCategoryDetailsRequest,
    handleGetAllInvestmentCategoryDetailsRequest,
  );
}

function* handleAddLoansWatcher() {
  yield takeEvery(
    actions.addLoansRequest,
    handleAddLoansRequest,
  );
}
function* handleUpdateLoansWatcher() {
  yield takeEvery(
    actions.updateLoansRequest,
    handleUpdateLoansRequest,
  );
}

function* handleGetLoansWatcher() {
  yield takeEvery(
    actions.getLoansRequest,
    handleGetLoansRequest,
  );
}

function* handleApplyAdvanceWatcher() {
  yield takeEvery(
    actions.applyAdvanceRequest,
    handleApplyAdvanceRequest,
  );
}
function* handleGetAdvanceApprovalWatcher() {
  yield takeEvery(
    actions.getAdvanceApprovalRequest,
    handleGetAdvanceApprovalRequest,
  );
}
function* handleGetAdvanceRequestWatcher() {
  yield takeEvery(
    actions.getAdvanceRequestRequest,
    handleGetAdvanceRequestRequest,
  );
}
function* handleApprovalRejectAdvanceWatcher() {
  yield takeEvery(
    actions.approvalRejectAdvanceRequest,
    handleApprovalRejectAdvanceRequest,
  );
}

function* handleEmployeeInvestmentProofWatcher() {
  yield takeEvery(
    actions.employeeInvestmentProofRequest,
    handleEmployeeInvestmentProofRequest,
  );
}

function* handleGetEmployeeInvestmentProofWatcher() {
  yield takeEvery(
    actions.getEmployeeInvestmentProofRequest,
    handleGetEmployeeInvestmentProofRequest,
  );
}

function* handleUpdateEmployeeInvestmentProofWatcher() {
  yield takeEvery(
    actions.updateEmployeeInvestmentProofRequest,
    handleUpdateEmployeeInvestmentProofRequest,
  );
}

function* handleDeleteEmployeeInvestmentProofWatcher() {
  yield takeEvery(
    actions.deleteEmployeeInvestmentProofRequest,
    handleDeleteEmployeeInvestmentProofRequest,
  );
}

function* handleCommentInEmployeeInvestmentProofWatcher() {
  yield takeEvery(
    actions.commentInEmployeeInvestmentProofRequest,
    handleCommentInEmployeeInvestmentProofRequest,
  );
}
function* handleCheckRuleFormulaWatcher() {
  yield takeEvery(
    actions.checkRuleFormulaRequest,
    handleCheckRuleFormulaRequest,
  );
}

function* handleGetAllEmployeeSalaryWatcher() {
  yield takeEvery(
    actions.getAllEmployeeSalaryRequest,
    handleGetAllEmployeeSalaryRequest,
  );
}

function* handleGetEmployeeMonthlySalaryWatcher() {
  yield takeEvery(
    actions.getEmployeeMonthlySalaryRequest,
    handleGetEmployeeMonthlySalaryRequest,
  );
}

function* handleGenerateSalarySlipWatcher() {
  yield takeEvery(
    actions.generateSalarySlipRequest,
    handleGenerateSalarySlipRequest,
  );
}

function* handleSendOfferLetterWatcher() {
  yield takeEvery(
    actions.sendOfferLetterRequest,
    handleSendOfferLetterRequest,
  );
}


function* handleGetCandidateSalaryWatcher() {
  yield takeEvery(
    actions.getCandidateSalaryRequest,
    handleGetCandidateSalaryRequest,
  );
}


function* handleUpdateEmployeeMonthlySalaryWatcher() {
  yield takeEvery(
    actions.updateEmployeeMonthlySalaryRequest,
    handleUpdateEmployeeMonthlySalaryRequest,
  );
}

function* handleDeleteEarningTypeWatcher() {
  yield takeEvery(
    actions.deleteEarningTypeRequest,
    handleDeleteEarningTypeRequest,
  );
}

function* handleDeleteDeductionTypeWatcher() {
  yield takeEvery(
    actions.deleteDeductionTypeRequest,
    handleDeleteDeductionTypeRequest,
  );
}


function* handleDeleteDeductionWatcher() {
  yield takeEvery(
    actions.deleteDeductionRequest,
    handleDeleteDeductionRequest,
  );
}

function* handleDeleteEarningWatcher() {
  yield takeEvery(
    actions.deleteEarningRequest,
    handleDeleteEarningRequest,
  );
}


function* handleDeleteSalaryTemplateWatcher() {
  yield takeEvery(
    actions.deleteSalaryTemplateRequest,
    handleDeleteSalaryTemplateRequest,
  );
}

function* handleGetEmployeeMonthlyPaySlipWatcher() {
  yield takeEvery(
    actions.getEmployeeMonthlyPaySlipRequest,
    handleGetEmployeeMonthlyPaySlipRequest,
  );
}

function* rootPayrollSaga() {
  yield all([
    handleGetEmployeeDetailsByPayDaysRequest(),
    handleGetEmployeeDetailsByPayDaysWatcher(),

    handleGetAttendanceStatusRequest(),
    handleGetAttendanceStatusWatcher(),

    handleUpdateAttendanceTrackingRequest(),
    handleUpdateAttendanceTrackingWatcher(),

    handleAddEarningsRequest(),
    handleAddEarningsWatcher(),

    handleUpdateEarningsRequest(),
    handleUpdateEarningsWatcher(),

    handleGetEarningsRequest(),
    handleGetEarningsWatcher(),

    handleAddDeductionsRequest(),
    handleAddDeductionsWatcher(),

    handleUpdateDeductionsRequest(),
    handleUpdateDeductionsWatcher(),

    handleGetDeductionsRequest(),
    handleGetDeductionsWatcher(),

    handleAddTaxSlabsRequest(),
    handleAddTaxSlabsWatcher(),

    handleAddEarningTypesRequest(),
    handleAddEarningTypesWatcher(),

    handleUpdateEarningTypesRequest(),
    handleUpdateEarningTypesWatcher(),

    handleGetEarningTypeRequest(),
    handleGetEarningTypeWatcher(),

    handleGetAllEarningTypeRequest(),
    handleGetAllEarningTypeWatcher(),

    handleGetEarningTypeByIdRequest(),
    handleGetEarningTypeByIdWatcher(),

    handleAddDeductionTypesRequest(),
    handleAddDeductionTypesWatcher(),

    handleUpdateDeductionTypesRequest(),
    handleUpdateDeductionTypesWatcher(),

    handleGetDeductionTypeRequest(),
    handleGetDeductionTypeWatcher(),

    handleGetAllDeductionTypeRequest(),
    handleGetAllDeductionTypeWatcher(),

    handleGetDeductionTypeByIdRequest(),
    handleGetDeductionTypeByIdWatcher(),

    handleGenerateSalaryTemplateRequest(),
    handleGenerateSalaryTemplateWatcher(),

    handleSaveSalaryTemplateRequest(),
    handleSaveSalaryTemplateWatcher(),

    handleGetAllSalaryTemplateRequest(),
    handleGetAllSalaryTemplateWatcher(),

    handleGetSalaryTemplateRequest(),
    handleGetSalaryTemplateWatcher(),

    handleUpdateSalaryTemplateRequest(),
    handleUpdateSalaryTemplateWatcher(),

    handleGetSalaryTemplateByIdRequest(),
    handleGetSalaryTemplateByIdWatcher(),


    handleGetAllEaringRequest(),
    handleGetAllEarningWatcher(),

    handleGetAllDeductionRequest(),
    handleGetAllDeductionWatcher(),

    handleAddArrearsRequest(),
    handleAddArrearsWatcher(),

    handleGetArrearsRequest(),
    handleGetArrearsWatcher(),

    handleCalculateCtcRequest(),
    handleCalculateCtcWatcher(),

    handleAddEmployeeSalaryRequest(),
    handleAddEmployeeSalaryWatcher(),

    handleGetEmployeeSalaryRequest(),
    handleGetEmployeeSalaryWatcher(),

    handleUpdateEmployeeSalaryRequest(),
    handleUpdateEmployeeSalaryWatcher(),

    handleGetAllEmployeeAssignStatusRequest(),
    handleGetAllEmployeeAssignStatusWatcher(),

    handleAddPayRunRequest(),
    handleAddPayRunWatcher(),

    handleAddPayScheduleRequest(),
    handleAddPayScheduleWatcher(),

    handleUpdatePayScheduleRequest(),
    handleUpdatePayScheduleWatcher(),

    handleUpcomingPayrollsRequest(),
    handleUpcomingPayrollsWatcher(),

    handlePayRollNotificationRequest(),
    handlePayRollNotificationWatcher(),

    handleGetPayRunRequest(),
    handleGetPayRunWatcher(),

    handleGetPayRunDashboardDataRequest(),
    handleGetPayRunDashboardDataWatcher(),

    handleGetPayRunHistoryRequest(),
    handleGetPayRunHistoryWatcher(),

    handleApprovePayrollRequest(),
    handleApprovePayrollWatcher(),

    handleAddTaxSlabRequest(),
    handleAddTaxSlabWatcher(),

    handleUpdateTaxSlabRequest(),
    handleUpdateTaxSlabWatcher(),

    handleGetTaxSlabRequest(),
    handleGetTaxSlabWatcher(),

    handleGetAllTaxSlabRequest(),
    handleGetAllTaxSlabWatcher(),

    handleDeleteTaxSlabRequest(),
    handleDeleteTaxSlabWatcher(),

    handleAddEmployeeInvestmentRequest(),
    handleAddEmployeeInvestmentWatcher(),

    handleGetEmployeeInvestmentRequest(),
    handleGetEmployeeInvestmentWatcher(),

    handleUpdateEmployeeInvestmentRequest(),
    handleUpdateEmployeeInvestmentWatcher(),

    handleDeleteEmployeeInvestmentRequest(),
    handleDeleteEmployeeInvestmentWatcher(),

    handleAddInvestmentCategoryRequest(),
    handleAddInvestmentCategoryWatcher(),

    handleUpdateInvestmentCategoryRequest(),
    handleUpdateInvestmentCategoryWatcher(),

    handleGetInvestmentCategoryRequest(),
    handleGetInvestmentCategoryWatcher(),

    handleGetAllInvestmentCategoryRequest(),
    handleGetAllInvestmentCategoryWatcher(),

    handleDeleteInvestmentCategoryRequest(),
    handleDeleteInvestmentCategoryWatcher(),

    handleAddInvestmentSubCategoryRequest(),
    handleAddInvestmentSubCategoryWatcher(),

    handleUpdateInvestmentSubCategoryRequest(),
    handleUpdateInvestmentSubCategoryWatcher(),

    handleGetInvestmentSubCategoryRequest(),
    handleGetInvestmentSubCategoryWatcher(),

    handleGetAllInvestmentSubCategoryRequest(),
    handleGetAllInvestmentSubCategoryWatcher(),

    handleDeleteInvestmentSubCategoryRequest(),
    handleDeleteInvestmentSubCategoryWatcher(),

    handleGetAllInvestmentCategoryDetailsRequest(),
    handleGetAllInvestmentCategoryDetailsWatcher(),

    handleAddLoansRequest(),
    handleAddLoansWatcher(),

    handleUpdateLoansRequest(),
    handleUpdateLoansWatcher(),

    handleGetLoansRequest(),
    handleGetLoansWatcher(),

    handleGetLoansRequest(),
    handleGetLoansWatcher(),

    handleApplyAdvanceRequest(),
    handleApplyAdvanceWatcher(),

    handleGetAdvanceApprovalRequest(),
    handleGetAdvanceApprovalWatcher(),

    handleGetAdvanceRequestRequest(),
    handleGetAdvanceRequestWatcher(),

    handleApprovalRejectAdvanceRequest(),
    handleApprovalRejectAdvanceWatcher(),

    handleCheckRuleFormulaRequest(),
    handleCheckRuleFormulaWatcher(),

    handleEmployeeInvestmentProofRequest(),
    handleEmployeeInvestmentProofWatcher(),

    handleGetEmployeeInvestmentProofRequest(),
    handleGetEmployeeInvestmentProofWatcher(),

    handleUpdateEmployeeInvestmentProofRequest(),
    handleUpdateEmployeeInvestmentProofWatcher(),

    handleDeleteEmployeeInvestmentProofRequest(),
    handleDeleteEmployeeInvestmentProofWatcher(),

    handleCommentInEmployeeInvestmentProofRequest(),
    handleCommentInEmployeeInvestmentProofWatcher(),

    handleGetAllEmployeeSalaryRequest(),
    handleGetAllEmployeeSalaryWatcher(),

    handleGetEmployeeMonthlySalaryRequest(),
    handleGetEmployeeMonthlySalaryWatcher(),

    handleGenerateSalarySlipRequest(),
    handleGenerateSalarySlipWatcher(),

    handleSendOfferLetterRequest(),
    handleSendOfferLetterWatcher(),


    handleGetCandidateSalaryRequest(),
    handleGetCandidateSalaryWatcher(),

    handleUpdateEmployeeMonthlySalaryRequest(),
    handleUpdateEmployeeMonthlySalaryWatcher(),

    handleDeleteDeductionRequest(),
    handleDeleteDeductionWatcher(),

    handleDeleteDeductionTypeRequest(),
    handleDeleteDeductionTypeWatcher(),

    handleDeleteEarningRequest(),
    handleDeleteEarningWatcher(),

    handleDeleteEarningTypeRequest(),
    handleDeleteEarningTypeWatcher(),

    handleDeleteSalaryTemplateRequest(),
    handleDeleteSalaryTemplateWatcher(),
    
    handleGetEmployeeMonthlyPaySlipRequest(),
    handleGetEmployeeMonthlyPaySlipWatcher(),

  ]);
}

export default rootPayrollSaga;
